module.exports = __webpack_public_path__ + "static/media/office.05873453.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/office.jpg
// module id = 599
// module chunks = 0